import $ from "jquery";
import {Module} from "wrapper6";

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation extends Module {
	ready(app) {
		/**
		 * Responsive Nav
		 */
		var header = $('#main_header'),
			pullMenu = $('.pull_menu'),
			line1 = $('.line-1'),
			line2 = $('.line-2'),
			line3 = $('.line-3'),
			nav = $('nav#main_nav'),
			canToggle = true,
			body = $('body');

		pullMenu.click(function() {

			var offset = $(window).scrollTop();

			if(canToggle) {
				canToggle = false;
				if(offset < 50){
					header.toggleClass('scrolled')
				}
				nav.css('transition', '300ms all ease');
				nav.toggleClass('pull_menu_in_out');
				line1.toggleClass('line-1-animate');
				line2.toggleClass('line-2-remove');
				line3.toggleClass('line-3-animate');
				body.toggleClass('no-scroll');

				setTimeout(function() {
					canToggle = true;
					nav.css('transition', 'none');
				}, 300);
			}
			// nav.css('transition', 'none');
			// body.toggleClass('no-scroll');
		});

		/**
		 * Add class to the navigation when scrolling down
		 */
		function scrolled() {
			var offset = $(window).scrollTop();
			var header = $('header#main_header')
			var scrolledClass = 'scrolled';

			if(offset > 50) {
				header.addClass(scrolledClass);
			} else {
				header.removeClass(scrolledClass);
			}
		}

		$(window).scroll(scrolled);

		$('li.menu-item-has-children').each(function() {

			var item = $(this);
			var added = true;

			item.on('click', function() {

				var ul = $(this).find('ul.sub-menu');
				var ulHeight = ul.height();

				if (added) {

					$(this).css('transition', 'all 0.2s ease-in-out');
					$(this).addClass('submenu-open');

					$(this).css({
					    marginBottom: ulHeight
					});

					var time = 100;

					$(this).find('ul').children().each(function(index){
					    var obj = $(this);
					    setTimeout(function(){
					        $(obj).addClass('slide-in');
					    }, time);
					    time += 50;
					});

					added = false;

				} else {

					var thisObj = $(this);

		            var time = 100;

		            $($(this).find('ul li').get().reverse()).each(function() {
		                var obj = $(this);
		                setTimeout(function(){
		                    $(obj).removeClass('slide-in');
		                }, time);
		                time += 50;
		            });

		            setTimeout(function(){
		                $(thisObj).css({
		                    marginBottom: '0px'
		                });

										$(thisObj).removeClass('submenu-open');

		            }, time);

		            added = true;

		        }

			});

		});

		$('.menu-item-has-children a').first().on('click', function(e){
			e.preventDefault();
		});

		$('.cover-link').click(function(e){
			e.preventDefault();
			var div = $(this).attr('href');
			$('html, body').animate({
		        scrollTop: $(div).offset().top - 80
		    }, 500);
		});
	}
}